import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";

import { header } from "../../sample";
import { ShaDowBox } from "../../../../../components/boxes";
import SettingHeader from "../../../../../components/SettingHeader";
import plus from "../../../../../assets/images/icons/plus.svg";
import trash from "../../../../../assets/images/icons/trash.svg";
import UsersCard from "./UsersCard";
import { AddUserModal } from "../../../../../components/modals/AddUserModal";
import { manageUser } from "../../sample";
import { SettingActions } from "../../../../../components/SettingHeader/settingActions";

export const useStyles = makeStyles(() => ({
  container: {
    marginLeft: 50,
    paddingTop: 40,
    paddingBottom: 23
  }
}));

const options = [
  {
    id: 0,
    label: "Executive",
    color: "#FF952B"
  },
  {
    id: 1,
    label: "Operator",
    color: "#6200EE"
  },
  {
    id: 2,
    label: "Basic",
    color: "#6EC1CB"
  },
  {
    id: 3,
    label: "Admin",
    color: "#FFFF00"
  }
];

export const UsersPermission = () => {
  const classes = useStyles();
  const [isopen, setOpen] = useState(false);
  const [userList, setUsersList] = useState([]);
  const [, setLoading] = useState(false);
  const [addUserLoader, setAddUserLoader] = useState(false);
  const [addUserDetails, setAddUserDetails] = useState({
    email: "",
    name: "",
    role: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getInitialData();
  }, []);

  function nameInitials(fullName) {
    const namesArray = fullName.trim().split(" ");
    if (namesArray.length === 1)
      return `${namesArray[0].charAt(0)}`.toUpperCase();
    else
      return `${namesArray[0].charAt(0)}${namesArray[
        namesArray.length - 1
      ].charAt(0)}`.toUpperCase();
  }

  const getInitialData = async () => {
    setLoading(true);
    try {
      const data = manageUser;
      setUsersList(data);
    } catch (e) {
      console.log(e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      const users = userList.filter((item) => item.id !== userId);
      setUsersList(users);
    } catch (e) {
      console.log(e.message, "message");
    }
  };

  const changeUserRole = async () => {};

  const handleUserDetails = (val, type) => {
    setAddUserDetails((prev) => {
      return {
        ...prev,
        [type]: val
      };
    });
  };

  const getUserDetails = (user) => {
    const errorState = {
      email: "Please enter email",
      strict: "Name Should Not Contain Any Numeric Value",
      minLength: "Name Should Have more than 4 characters",
      empty: "Name Should Not be empty"
    };
    const errors = {};
    let first_name = "";
    let last_name = "";
    if (user) {
      const letters = /^[a-zA-Z ]*$/;
      if (!addUserDetails.email) {
        errors["email"] = errorState.email;
      }
      if (!letters.test(user)) {
        errors["userName"] = errorState.strict;
      }
      if (user.length < 5) {
        errors["userName"] = errorState.minLength;
      }
      let nameArray = user.split(" ");
      if (nameArray.length == 1) first_name = nameArray[0];
      first_name = nameArray.slice(0, -1).join(" ");
      last_name = nameArray.slice(-1).join(" ");
    } else {
      errors["userName"] = errorState.empty;
    }
    return {
      first_name,
      last_name,
      errors
    };
  };

  const handleAddUser = async () => {
    setAddUserLoader(true);
    setErrors({});
    const { first_name, last_name, errors } = getUserDetails(
      addUserDetails.name
    );
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      setLoading(false);
      setAddUserLoader(false);
      return;
    }
    try {
      if (addUserDetails.name && addUserDetails.email && addUserDetails.role) {
        const userDetails = {
          id: Math.floor(Math.random() * 100),
          first_name: first_name,
          last_name: last_name || "",
          email: addUserDetails.email,
          profile_image: null,
          role: addUserDetails.role.toUpperCase(),
          currency: "USD",
          preferred_language: "ENGLISH"
        };
        setUsersList([...userList, userDetails]);
      }
    } catch (e) {
      console.log(e.message, "error");
    } finally {
      setAddUserLoader(false);
      setOpen(false);
    }
  };

  return (
    <>
      <SettingActions />
      <ShaDowBox style={{ height: "100%" }}>
        <div className={classes.container}>
          <SettingHeader
            title={header.userspermissions.title}
            subtitle={header.userspermissions.subtitle}
            img={header.userspermissions.img}
            buttonIcon={plus}
            buttonText="Add"
            mr="20%"
            setOpen={setOpen}
          />
          <div>
            {userList?.map((item, i) => {
              return (
                <UsersCard
                  xs={5}
                  key={i}
                  options={options}
                  shortName={nameInitials(
                    `${item.first_name} ${item?.last_name || ""}`
                  )}
                  userId={item.id}
                  userrole={item.role}
                  email={item.email}
                  name={`${item.first_name} ${item?.last_name || ""}`}
                  deleteIcon={trash}
                  handleDeleteUser={handleDeleteUser}
                  changeUserRole={changeUserRole}
                />
              );
            })}
          </div>
        </div>
        <AddUserModal
          isOpen={isopen}
          setOpen={setOpen}
          addUserDetails={addUserDetails}
          handleUserDetails={handleUserDetails}
          handleAddUser={handleAddUser}
          loader={addUserLoader}
          errors={errors}
        />
      </ShaDowBox>
    </>
  );
};
